export default {
  'seivice.orderResponse': '订单响应',
  'seivice.material': '物料',
  'seivice.warehouse': '仓库',
  'seivice.profAtersalesTeam': '专业售后队伍'
}
